module.exports = __webpack_public_path__ + "static/media/surf2.c8141404.svg";